
import 'swiper/css/swiper.css'
import { Component, Vue } from 'vue-property-decorator'
import RealNameAuth from '@/components/RealNameAuth.vue';
import CommonUtils from '@/common-utils';

@Component({components:{RealNameAuth}})
export default class ProfileRealNameAuth extends Vue{

  get nextUrl(): string {
    return CommonUtils.createStaticUrl(this, 'MemberInfo');
  }

}
